const  AboutPage = () => {
  return (
    <div className="pt-24 pb-16">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h1 className="font-serif text-4xl mb-2">Our Story</h1>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Discover the passion and craftsmanship behind Lustre & Co.
          </p>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-20">
          <div>
            <img 
              src="https://images.unsplash.com/photo-1611085583191-a3b181a88401?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=800&q=80" 
              alt="Our Story" 
              className="w-full h-[600px] object-cover"
            />
          </div>
          <div>
            <h2 className="font-serif text-3xl mb-6">Our Beginning</h2>
            <p className="text-gray-600 mb-4">
              Founded in 2005 by master jeweler Elena Thornton, Lustre & Co. began as a small atelier in New York's 
              diamond district. Elena's vision was simple yet ambitious: to create jewelry that combines old-world 
              craftsmanship with contemporary design.
            </p>
            <p className="text-gray-600 mb-4">
              With a background in traditional goldsmithing and a passion for innovative design, Elena assembled a team 
              of skilled artisans who shared her commitment to quality and creativity.
            </p>
            <p className="text-gray-600">
              What started as a boutique studio quickly gained recognition for its distinctive aesthetic and impeccable 
              craftsmanship, attracting clients who appreciate the artistry and attention to detail that defines each 
              Lustre & Co. creation.
            </p>
          </div>
        </div>
        
        <div className="mb-20">
          <h2 className="font-serif text-3xl text-center mb-12">Our Philosophy</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center p-6">
              <img 
                src="https://images.unsplash.com/photo-1552667466-07770ae110d0?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=500&q=80" 
                alt="Craftsmanship" 
                className="w-full h-64 object-cover mb-4"
              />
              <h3 className="font-serif text-xl mb-3">Craftsmanship</h3>
              <p className="text-gray-600">
                We believe in creating jewelry by hand, employing techniques that have been passed down through generations 
                of master jewelers. Each piece receives the time and attention it deserves.
              </p>
            </div>
            <div className="text-center p-6">
              <img 
                src="https://images.unsplash.com/photo-1610694955371-d4a3e0ce4b52?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=500&q=80" 
                alt="Quality Materials" 
                className="w-full h-64 object-cover mb-4"
              />
              <h3 className="font-serif text-xl mb-3">Quality Materials</h3>
              <p className="text-gray-600">
                We source only the finest materials, from ethically mined diamonds and gemstones to recycled precious metals, 
                ensuring each creation meets our exacting standards.
              </p>
            </div>
            <div className="text-center p-6">
              <img 
                src="https://images.unsplash.com/photo-1611591437281-460bfbe1220a?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=500&q=80" 
                alt="Timeless Design" 
                className="w-full h-64 object-cover mb-4"
              />
              <h3 className="font-serif text-xl mb-3">Timeless Design</h3>
              <p className="text-gray-600">
                Our designs balance contemporary aesthetics with enduring elegance, creating pieces that transcend trends 
                and can be cherished for generations.
              </p>
            </div>
          </div>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-20">
          <div className="order-2 lg:order-1">
            <h2 className="font-serif text-3xl mb-6">Our Artisans</h2>
            <p className="text-gray-600 mb-4">
              Behind every Lustre & Co. creation is a team of dedicated artisans who bring decades of experience to their craft. 
              Our jewelers, stone setters, and polishers work collaboratively, each contributing their specialized expertise to 
              the creation process.
            </p>
            <p className="text-gray-600 mb-4">
              Many of our artisans trained in traditional European workshops before joining Lustre & Co., bringing with them 
              techniques and knowledge that have been refined over centuries.
            </p>
            <p className="text-gray-600">
              We are committed to preserving these traditional crafts while embracing innovation, creating an environment where 
              artistry flourishes and exceptional jewelry is born.
            </p>
          </div>
          <div className="order-1 lg:order-2">
            <img 
              src="https://images.unsplash.com/photo-1492707892479-7bc8d5a4ee93?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=800&q=80" 
              alt="Lustre & Co. artisans at work" 
              className="w-full h-auto"
            />
          </div>
        </div>
        
        <div className="text-center mb-16">
          <h2 className="font-serif text-3xl mb-6">Visit Our Atelier</h2>
          <p className="text-gray-600 max-w-2xl mx-auto mb-8">
            We invite you to visit our atelier in New York's diamond district, where you can meet our artisans, 
            explore our collections, and experience the craftsmanship that defines Lustre & Co.
          </p>
          <div className="bg-beige-light p-8 inline-block">
            <h3 className="font-serif text-xl mb-4">Opening Hours</h3>
            <div className="space-y-2">
              <p>Monday - Friday: 10am - 6pm</p>
              <p>Saturday: 11am - 5pm</p>
              <p>Sunday: By appointment only</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
 